import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { StateService } from 'src/app/state.service';
import { AlertComponent } from '../alert/alert.component';


export interface ActionIcon {
  //interface action icons top right
  icon: string;
  title: string;
  routerLink: string;
  clickMethod: string;
  hide?: boolean;
}

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit, OnDestroy {

  id: string;
  name: string;
  tab: number = 0;
  copy: boolean = false;

  disableByProfile: boolean = false;
  profilesAllowEdit: string = '';

  columnsVisible: Map<string, boolean> = new Map<string, boolean>();

  buttonCancel: string;
  buttonConfirm: string;
  saveIconTitle: string;
  copyIconTitle: string;
  cancelIconTitle: string;

  dialogTitle: string = "";

  deleteConfirmText: string;
  deleteIconTitle: string;
  dialogTitleText: string= "";
  routePath: string;

  protected listData: any[];

  topMenuIcons: ActionIcon[] = [];

  detailForm: UntypedFormGroup = new UntypedFormGroup({});

  //inject op deze manier als niet gebruikt in afgeleide classes
  private route = inject(ActivatedRoute);
  public dialog = inject(MatDialog);
  public stateService = inject(StateService);
  public cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  hidePrevious: boolean;
  hideNext: boolean;

  constructor(
    public translate: TranslateService,
    public sidenavService: SideNavService,
    public router: Router
    ) {
      const state = this.router.getCurrentNavigation()?.extras.state as any;
    if (state) {
      this.listData = state.listdata;
    }
    }

    ngOnInit(): void {

      this.route.url.subscribe((event) => {
        event[0] ? this.routePath = event[0].path : '';
      });


      //get item by input id or init new item
      if (!this.id)
        this.id = this.route.snapshot.params['id'];

      this.copy = this.route.snapshot.queryParams['copy'];

      if (!this.tab)
      {
        this.tab = this.route.snapshot.queryParams['tab'];
      }

      if (this.id && this.id !== 'new')
      {
        this.getItem({ id: this.id });
      } else
      {
        this.initItem();
      }
    }

    ngOnDestroy(): void {

    }

    initDialogDelete(dialogTitle: string)
    {
      this.dialogTitle = dialogTitle;
      this.init();
    }

  init() {
    //translations
    this.translate.get(['button.cancel', 'button.confirm', this.dialogTitle, 'icon.save-title', 'icon.delete-title', 'icon.cancel-title', 'icon.copy-title']).subscribe((translations: string) => {
      this.buttonCancel = translations['button.cancel'];
      this.buttonConfirm = translations['button.confirm'];
      this.saveIconTitle = translations['icon.save-title'];
      this.copyIconTitle = translations['icon.copy-title'];
      this.cancelIconTitle = translations['icon.cancel-title'];
      this.deleteIconTitle = translations['icon.delete-title'];
      this.dialogTitleText = translations[this.dialogTitle];
    });
  }

  extraChecksBeforeSave()
  {
    return true;
  }

  save() {
    if (this.detailForm.valid && this.extraChecksBeforeSave())
    {
      this.saveOk();
    }
  }

  saveOk()
  {
    this.sidenavService.setLoading(true);
  }

  delete() {
    this.sidenavService.setLoading(true);
  }

  deleteConfirm()
  {
    //use a confirmDialog box before delete
    this.deleteConfirmText = this.translate.instant('delete.confirm', { name:this.name });
    const confirmDialog = this.dialog.open(AlertComponent, {
      data: {message: this.deleteConfirmText, type: this.dialogTitleText, buttonCancel: this.buttonCancel, buttonConfirm: this.buttonConfirm }, hasBackdrop: true }

    );
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete();
      }
    });
  }

  copyItem()
  {
    this.copy = true;
    const sortingAndPaginationQueryParams = {
      copy: 'true'
    };

    this.router.navigate([], {
      queryParams: sortingAndPaginationQueryParams,
      queryParamsHandling: 'merge',
    });
  }

  getItem(_request) {
    //get the detail item
  }

  initItem() {
    //init an empty item for new
  }

  initForm()
  {
    this.hidePrevious = true;
    this.hideNext = true;

    if (this.listData && this.listData.length > 1)
    {
      if (this.id !== this.listData[0])
      {
        this.hidePrevious = false;
      }
      if (this.id !== this.listData[this.listData.length - 1])
      {
        this.hideNext = false;
      }
    }
    //set topmenu icons
  }

  setForm()
  {
    //set visibility, validators
    if (this.stateService.getProfile())
      {
        this.setEnabled(this.stateService.getProfile().toString());
      }
      else
      {
        this.stateService.userProfile$.pipe(filter(val => val != null)).subscribe((userProfile) => {
          this.setEnabled(userProfile.toString());
        });
      }
    }

    setEnabled(userProfile: string)
    {
      if (userProfile && this.profilesAllowEdit.includes(userProfile))
      {
        this.disableByProfile = false;
      }
      else this.disableByProfile = true;
    }

  refresh() {
    if (this.id && this.id !== 'new')
      this.getItem({ id: this.id });
    else this.initItem();
  }

  navigateNext()
  {
    this.navigate(1);
  }

  navigatePrevious()
  {
    this.navigate(-1);
  }

  navigate(add: number)
  {
      //previous, next
      let index = -1;
      if (this.listData)
      {
        let currentInList = this.listData.filter((d) => d === this.id);
        if (currentInList)
        {
          let currentIndex = (add > 0) ? this.listData.lastIndexOf(currentInList[0]) : this.listData.indexOf(currentInList[0]);
          index = currentIndex + add;
        }

        if (index > -1 && index < this.listData.length)
        {
          let newUrl = this.router.url.replace(this.id, this.listData[index]);
          let sp = newUrl.split('?');
          if (sp && sp.length > 0)
          {
            newUrl = sp[0];
          }
          this.id = this.listData[index];
          this.cdr.detectChanges();

          //this.detailForm.reset();
          this.refresh();
          //this.router.navigateByUrl(newUrl, {
          //  state: { listdata: this.listData }
         // });
        }
        //else this.router.navigateByUrl(newUrl);
    }
}

  dummy() {
    //do nothing
  }

  setRouterTab(tab: number)
  {
    this.tab = tab;
    const sortingAndPaginationQueryParams = {
      tab: this.tab
    };

    this.router.navigate([], {
      queryParams: sortingAndPaginationQueryParams,
      queryParamsHandling: 'merge',
    });
  }



  countDecimalPlaces(number)
  {
    if(number)
    {
      const decimalIndex = number.toString().indexOf('.');
      let r =  decimalIndex >= 0 ? number.toString().length - decimalIndex - 1 : 0;
      let result = 1;

      for (let i = 0; i < r; i++)
      result = result * 10;

      return 1 / result;
    }

    else return 1;
  }

}
